import styled from '@emotion/styled';
import React, { useState } from 'react';
import { AiOutlineUser } from 'react-icons/ai';
import { Button, Dialog } from '@104ha/base-ui';
import { useAuth, useLogout } from '../hook/use-auth';
import { useRouter } from '../hook/use-router';

const Wrapper = styled.div`
	height: 68px;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
	background-color: #ffffff;
	z-index: 10;
	display: flex;
	align-items: center;
	color: #292929;
	justify-content: space-between;
	padding: 0 24px;
	position: relative;
	font-size: 16px;

	& .-ehrms2:after {
		font-size: 16px;
		content: 'HR MAX APIs';
	}

	& .-ehrms2:before {
		width: 40px;
		height: 30px;
	}
`;

const Logo: React.FC<{ classname?: string }> = ({ classname }) => {
	const router = useRouter();
	return (
		<div>
			<div
				className="-ehrms2"
				onClick={() => {
					router.push('/');
				}}
			></div>
		</div>
	);
};

const UserIcon = styled(AiOutlineUser)<{ size?: number }>`
	font-size: ${(props) => props.size || 24 + 'px'};
	/* margin-right: 8px; */
`;

const UserWrapper = styled.div`
	display: flex;
	align-items: center;
	cursor: pointer;

	.-name {
		margin-left: 16px;
	}
`;

const DialogContent = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;

	.-icon-wrapper {
		border: 1px solid black;
		border-radius: 50%;
		padding: 10px;
	}

	div {
		margin: 12px auto;
	}
`;

const User: React.FC<{ username?: string; onClick?: () => any }> = ({ username, onClick }) => {
	return (
		<UserWrapper onClick={onClick}>
			<UserIcon />
			<span className="-name">{username}</span>
		</UserWrapper>
	);
};

export default function Header() {
	const [show, setShow] = useState(false);
	const { userName } = useAuth();
	const logout = useLogout();

	return (
		<Wrapper className="H2-Header">
			<Logo />
			{show ? (
				<Dialog width={500} close={() => setShow(false)} isFooter={false} title="">
					<DialogContent>
						<div className="-icon-wrapper">
							<UserIcon size={80} />
						</div>
						<div>{userName}</div>
						<Button.Normal onClick={() => logout()}>登出</Button.Normal>
					</DialogContent>
				</Dialog>
			) : null}
			<User
				username={userName}
				onClick={() => {
					setShow(true);
				}}
			/>
		</Wrapper>
	);
}
